/* Bloc Astrologie — reveal scroll + respect prefers-reduced-motion */
(function () {
  'use strict';

  const section = document.querySelector('.astro-section');
  if (!section) return;

  const prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReduce) {
    section.classList.add('is-revealed');
    return;
  }

  if (!('IntersectionObserver' in window)) {
    section.classList.add('is-revealed');
    return;
  }

  // Rejoue à chaque entrée dans l'écran ; remet l'état caché à la sortie
  // (ne s'anime donc jamais hors écran, et l'effet rejoue si on revient en arrière).
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
        } else {
          entry.target.classList.remove('is-revealed');
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -10% 0px' }
  );

  observer.observe(section);
})();
